module.exports = __webpack_public_path__ + "frontend/static/media/House Hold Gadgets.74975050.png";